import {patchState, signalStore, withComputed, withHooks, withMethods, withState} from '@ngrx/signals';
import {CatalogState} from './catalog.state';
import {computed, inject} from '@angular/core';
import {rxMethod} from '@ngrx/signals/rxjs-interop';
import {pipe, switchMap, tap} from 'rxjs';
import {withUiFeature} from './features/ui.feature';

import {ApiCatalog} from '../services/api.catalog';

const initialState: CatalogState = {
  categories: [],
  products: [],
  product: null,
  categoryNames: [],
  categoryName: ''
};

export const CatalogStore = signalStore(
    {providedIn: 'root'},
    withState(initialState),

    withUiFeature(),
    withComputed((store) => {
      const userFavorites = computed(() =>
        store.categories().flatMap(cat => cat.products || []).filter(p => p.isFavorite)
      );

      return {
        userFavorites,
        favoritesCount: computed(() => userFavorites().length),
      };
    }),
    withMethods((store, catalogApi = inject(ApiCatalog)) => {

      return {
        findProduct: (productId: number) => {
          const product = store.products().find(p => p.productId === productId) || null;
          patchState(store, {product});
        },
        allProducts: (categoryId: number) => {
          const categories = store.categories();
          const category = categories.find(c => c.categoryId === categoryId);
          const products = category?.products || [];
          patchState(store, {categoryName: category?.name || '', products});
        },
        findAllCategories: rxMethod<void>(
          pipe(switchMap(() => catalogApi.findAllCategories().pipe(
            tap(categories => patchState(store, {categories}))
          )))
        ),
      };
    }),
    withHooks({
      onInit(store) {
        store.findAllCategories();
      }
    })
  )
;
